module.exports = __webpack_public_path__ + "static/media/poppins-regular.4fc29212.woff";